module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/003acknowledgments"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h1"
    }
  }, [_vm._v("Why I love crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h2"
    }
  }, [_vm._v("How I chose the recipes for this book")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h3"
    }
  }, [_vm._v("Choosing your pan—do you need something special?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h4"
    }
  }, [_vm._v("Other equipment for crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h5"
    }
  }, [_vm._v("Equipment you’ll need to make the fillings and toppings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h6"
    }
  }, [_vm._v("Ingredients for making your crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h7"
    }
  }, [_vm._v("Thoughts on technique")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h8"
    }
  }, [_vm._v("How to reheat crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction#h9"
    }
  }, [_vm._v("How to fold crêpes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006part1"
    }
  }, [_vm._v("THE BASIC CRÊPE RECIPES")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1"
    }
  }, [_vm._v("Versatile Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2"
    }
  }, [_vm._v("Gluten-Free Rice Flour Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3"
    }
  }, [_vm._v("Chickpea Flour Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4"
    }
  }, [_vm._v("Whole-Wheat Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5"
    }
  }, [_vm._v("Buckwheat Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6"
    }
  }, [_vm._v("Almond-Brown Butter Crêpes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "p2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013part2"
    }
  }, [_vm._v("SAVORY DISHES")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter7"
    }
  }, [_vm._v("Pesto and Crème Fraîche Crêpes with Arugula Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter8"
    }
  }, [_vm._v("Crêpes with Roasted Maple-Thyme Butternut Squash, Stilton, and Hazelnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter9"
    }
  }, [_vm._v("Roasted Eggplant, Tomato, and Garlic Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017chapter10"
    }
  }, [_vm._v("Hummus, Roasted Red Pepper, and Feta Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018chapter11"
    }
  }, [_vm._v("Spiced Indian Potato and Chickpea Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/019chapter12"
    }
  }, [_vm._v("Crêpes with Sautéed Pears, Aged Gouda, and Fresh Thyme")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/020chapter13"
    }
  }, [_vm._v("Swiss Chard and Goat Cheese Crêpes with Crunchy Walnut Crumb Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/021chapter14"
    }
  }, [_vm._v("Spicy Beef Picadillo Crêpes with Chipotle Crema")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/022chapter15"
    }
  }, [_vm._v("Beef Stroganoff Crêpes with Dijon Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/023chapter16"
    }
  }, [_vm._v("Gluten-Free Pork and Beef Cannelloni with Herbed Tomato Sauce and Parmigiano-Reggiano")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/024chapter17"
    }
  }, [_vm._v("Moo Shu Pork Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/025chapter18"
    }
  }, [_vm._v("Asparagus and Prosciutto Crêpes with Lemon-Caper Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/026chapter19"
    }
  }, [_vm._v("Classic Ham and Gruyère Crêpe with a Touch of Dijon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/027chapter20"
    }
  }, [_vm._v("Leek, Apple, Fennel Sausage, and Goat Cheese Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/028chapter21"
    }
  }, [_vm._v("Chicken and Mushroom Paprikás Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/029chapter22"
    }
  }, [_vm._v("Chicken Pot Pie Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/030chapter23"
    }
  }, [_vm._v("Smoked Salmon Cocktail Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/031chapter24"
    }
  }, [_vm._v("Lox, Egg, and Onion Crêpe Bundles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/032chapter25"
    }
  }, [_vm._v("Mediterranean Tuna Tapenade Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/033chapter26"
    }
  }, [_vm._v("Crab, Avocado, and Citrus Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/034chapter27"
    }
  }, [_vm._v("Smoky Pepper, Mashed Potato, and Shrimp Crêpes with Roasted Green Beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "p3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/035part3"
    }
  }, [_vm._v("SWEET DISHES")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/036chapter28"
    }
  }, [_vm._v("Butter-Sugar-Lemon Crêpe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/037chapter29"
    }
  }, [_vm._v("Hazelnut Soufflé Crêpes with Raspberry Coulis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/038chapter30"
    }
  }, [_vm._v("Ricotta Blintzes with Blueberry-Lime Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/039chapter31"
    }
  }, [_vm._v("Crêpes with Passion Fruit Pudding and Blueberry Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/040chapter32"
    }
  }, [_vm._v("Coconut Cream Crêpes with Mango-Lime Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/041chapter33"
    }
  }, [_vm._v("Roasted Pineapple Crêpes with Toasted Coconut–Macadamia Crunch and Spiced Rum-Butter Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/042chapter34"
    }
  }, [_vm._v("Profiterole Crêpes with Hot Chocolate Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/043chapter35"
    }
  }, [_vm._v("Bittersweet Chocolate Whipped Cream Crêpes with Mocha Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/044chapter36"
    }
  }, [_vm._v("Buttery Apple Crêpes with Cinnamon Custard and Salted Caramel Sauces")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/045chapter37"
    }
  }, [_vm._v("Crêpes with Vanilla-Peach Compote and Bourbon Caramel Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/046chapter38"
    }
  }, [_vm._v("Baked Almond Frangipane Crêpes with Spiced Plum Compote and Vanilla Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/047chapter39"
    }
  }, [_vm._v("Mixed Berry Crêpes with Ginger and Mascarpone")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/048chapter40"
    }
  }, [_vm._v("Whole-Wheat Crêpes with Fromage Blanc and Cardamom-Ginger Poached Apricots")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/049chapter41"
    }
  }, [_vm._v("Gluten-Free Rice Flour Crêpes with Wine-Poached Cherries")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/050chapter42"
    }
  }, [_vm._v("Strawberry Crêpes with Brown Sugar–Pecan Streusel and Sour Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/051chapter43"
    }
  }, [_vm._v("Spiced Tangerine Crêpes Suzette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/052chapter44"
    }
  }, [_vm._v("Banoffee Crêpes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/053chapter45"
    }
  }, [_vm._v("Crêpes with Roasted Rhubarb and Lemon Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/054chapter46"
    }
  }, [_vm._v("Mile-High Meyer Lemon and Whipped Cream Crêpe Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/055chapter47"
    }
  }, [_vm._v("Fancy Crêpe Layer Cake with Chocolate-Almond and Espresso Fillings")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/056index"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/057copyright"
    }
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df14236e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004-toc.vue
// module id = 66
// module chunks = 0